import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Chip,
  withStyles,
} from '@material-ui/core';

import localization from '../../../utils/localizations';
import nl from '../../../utils/namespacedLocalizations';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
}));


const GreenChip = withStyles((theme) => ({
  root: {
    color: '#ffffff',
    backgroundColor: '#689f38',
  },
}))(Chip);

const RedChip = withStyles((theme) => ({
  root: {
    color: '#ffffff',
    backgroundColor: '#d32f2f',
  },
}))(Chip);

const YellowChip = withStyles((theme) => ({
  root: {
    color: '#000000',
    backgroundColor: '#fbc02d',
  },
}))(Chip);

const BlueChip = withStyles((theme) => ({
  root: {
    color: '#ffffff',
    backgroundColor: '#0288d1',
  },
}))(Chip);

const GreyChip = withStyles((theme) => ({
  root: {
    color: '#ffffff',
    backgroundColor: '#616161',
  },
}))(Chip);


function StatusChip(props: {
  status: string;
  size?: "medium" | "small" | undefined;
  className?: string;
  namespace?: string;
}) {
  const classes = useStyles();
  let ChipComponent: any = Chip;

  switch (props.status) {
    case 'accepted':
    case 'approved':
    case 'completed':
      ChipComponent = GreenChip;
      break;
    case 'scheduled':
    case 'submitted':
      ChipComponent = BlueChip;
      break;
    case 'canceled':
    case 'rejected':
      ChipComponent = RedChip;
      break;
    case 'closed':
      ChipComponent = GreyChip;
      break;
    case 'approved_with_revision':
    case 'presentation_required':
    case 'revision_required':
      ChipComponent = YellowChip;
      break;

    default:
      ChipComponent = GreyChip;
      break;
  }

  const statusLabel = nl(props.status, props.namespace);

  return (
    <ChipComponent
      size={props.size}
      label={statusLabel.toLowerCase()}
      color="primary"
      className={props.className}
    />
  );
}

export {StatusChip};